import gql from 'graphql-tag';
const PAINTED_FINGER_CLUE_ACTIVITY_FRAGMENT = gql `
  fragment PaintedFingerClueActivityFragment on PaintedFingerClueActivity {
    targetKey
    rounds {
      id
      keystrokes
    }
  }
`;
export default PAINTED_FINGER_CLUE_ACTIVITY_FRAGMENT;
